import React from 'react';

interface IconRoundedWarningProps extends React.SVGProps<SVGSVGElement> {
    className?: string;
}

// The triangle takes `currentColor` and the "!" is cut out of it, so the background shows through. Its bar,
// gap and dot sit on the 2.5-unit grid of a 16 px render: off that grid, anti-aliasing fills the gap.
export const IconRoundedWarning: React.FC<IconRoundedWarningProps> = ({ className, ...props }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20" height="20"
        viewBox="0 0 40 40"
        aria-hidden="true"
        className={className}
        {...props}
    >
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M39.16,32.95L23.07,3.59c-1.33-2.42-4.8-2.42-6.13,0L.84,32.95c-1.28,2.33.41,5.18,3.07,5.18h32.19c2.66,0,4.34-2.85,3.07-5.18ZM22.5,32.5h-5v-5h5v5ZM22.5,22.5h-5v-12.5h5v12.5Z"
        />
    </svg>
);
